import Uploady from '@rpldy/uploady';
import { ReactNode } from 'react';

interface IProps {
  children?: ReactNode;
}

const ImageUploady = ({ children }: IProps) => {
  return (
    <Uploady
      accept="image/png, image/jpeg, image/gif, image/webp, image/avif"
      multiple={false}
      concurrent={false}
      grouped={false}
      clearPendingOnAdd={true}
      autoUpload={true}
    >
      {children}
    </Uploady>
  );
};

export default ImageUploady;
